import { QueryClient } from "@tanstack/react-query";
import { ApiException } from "@/services/api/axiosInstance";

/**
 * Default query options for all queries
 */
const defaultQueryOptions = {
  queries: {
    // Time before data is considered stale (5 minutes)
    staleTime: 1000 * 60 * 5,
    // Time before inactive queries are garbage collected (10 minutes)
    gcTime: 1000 * 60 * 10,
    // Retry configuration
    retry: (failureCount: number, error: unknown) => {
      // Don't retry on 4xx errors (client errors)
      if (
        error instanceof ApiException &&
        error.status >= 400 &&
        error.status < 500
      ) {
        return false;
      }
      // Retry up to 3 times for other errors
      return failureCount < 3;
    },
    retryDelay: (attemptIndex: number) =>
      Math.min(1000 * 2 ** attemptIndex, 30000),
    // Refetch on window focus (useful for keeping data fresh)
    refetchOnWindowFocus: false,
    // Refetch on reconnect
    refetchOnReconnect: true,
  },
  mutations: {
    // Retry mutations once on failure
    retry: 1,
    retryDelay: 1000,
  },
};

/**
 * Create and configure the QueryClient instance
 */
export const queryClient = new QueryClient({
  defaultOptions: defaultQueryOptions,
});
